import { Seo } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { ShieldCheck, House, HeartStraight } from "@phosphor-icons/react";

export default function About() {
  return (
    <>
      <Seo title="About Us" path="/about" description="Avinya Bookings helps customers discover and book farmhouses, resorts, banquet halls and function halls around Hyderabad." />
      <div className="px-4 py-8 md:px-6">
        <div className="mx-auto max-w-3xl">
          <h1 className="font-heading text-3xl font-bold text-stone-900 md:text-4xl">About Avinya Bookings</h1>
          <p className="mt-4 text-base leading-relaxed text-stone-600">
            Avinya Bookings helps customers discover and book suitable farmhouses, resorts, banquet halls and function halls.
            We focus initially on Hyderabad and the surrounding areas, making it simple to find the right place for family gatherings,
            celebrations, weekend stays and events.
          </p>
          <p className="mt-4 text-base leading-relaxed text-stone-600">
            Our goal is a clear, trustworthy booking experience — transparent pricing, secure online advance payments, and direct
            communication between customers and property owners.
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {[
              { icon: House, t: "Curated venues", d: "Farmhouses, resorts, banquet halls and function halls in one place." },
              { icon: ShieldCheck, t: "Verified listings", d: "Properties pass an Avinya review before going live." },
              { icon: HeartStraight, t: "Book. Relax. Celebrate.", d: "A smooth journey from search to your special day." },
            ].map((x) => (
              <div key={x.t} className="rounded-2xl border border-stone-200 bg-white p-5">
                <x.icon size={26} weight="duotone" className="text-primary" />
                <p className="mt-2 font-heading font-semibold">{x.t}</p>
                <p className="mt-1 text-sm text-stone-500">{x.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
